import React, { useEffect, useState } from "react";

import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";

import assets from "./assets";

import "./style/style.scss";
import "./style/animation.scss";
import useAnimation from "../../../../shared/hooks/useAnimation";
import ProgressBar from "../../../../shared/components/ProgressBar";
import GreenGlow from "../../_partials/GreenGlow";
import InsightZoneLogo from "../../_partials/InsightZoneLogo";
import GoalLine from "./goalLine";
import Goals from "./goals";
import _, { sortBy, split } from "lodash";
import parseMediaUrl from "../../../../shared/functions/parseMediaUrl";
import getContentById from "../../../../shared/utils/getContentById";
import { getScaleSize } from "../Lineup/Index";
import Functions from "../../../../shared/components/MediaLibrary/EditModal/functions";
import { getImageFilterStyle, getWrapperDimensions } from "../../../../shared/components/MediaLibrary/EditModal/ImageEditorModal";
import { DEFAULT_ADJUSTMENTS } from "../../../../frontend/constants/constants.js";
import { PresetColors, ResultTimes } from "../../../../shared/components/MediaLibrary/EditModal/LeftSidebar/EditTab.js";
import { dfbPokalId, uefaID } from "../ImageTable/Index.jsx";
import ResultOverlay from "./ResultOverlay.jsx";
import { DEFAULT_SCRIM_HEIGHT, bottomScrimStyle, ratioFromFormat } from "./helpers";

// Re-exported so the existing `from ".../ResultsNew/Index"` imports elsewhere
// keep working; the implementations live in ./helpers.
export {
  sortByTimeFirst,
  ratioFromFormat,
  formatFromRatio,
  ratioStringFromFormat,
  parseMinute,
  formatMinute,
} from "./helpers";

// const getMainBackground = () => {
//   return assets.background_1920;
// };

const getMainBackground = (format) => {
  if (format === "1200x1500") {
    return _.get(assets, `mainbackground_1200`);
  }

  if (format === "1080x1920") {
    return _.get(assets, `mainbackground_1080`);
  }
};

const FCBResultsView = ({ animation, data, mode, format, prevRatio, _searchParams, ...props }) => {
  const templateName = data?.template_name ?? "";
  const id = `${templateName}_${data?.uuid}`;

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };
  useAnimation({
    mode,
    animation,
    id,
    animationScript,
    animationCleanUp,
    callback: prepareAnimation,
    apiSetup: props?.apiSetup,
    data,
  });

  const { fields, editData } = data.data;

  const { matchDetails = {} } = data?.data?.dynamic ?? {};
  const manualEntries = editData?.manualEntries;

  let currentMatchTime = matchDetails?.matchTime ?? matchDetails?.matchLengthMin ?? 0;
  const period = matchDetails?.period;
  let firstHalfExtra = 0;
  if (period) {
    firstHalfExtra = period?.[0].announcedInjuryTime / 60 ?? 0;
  }
  if (firstHalfExtra > 0) {
    currentMatchTime -= firstHalfExtra;
  }

  const customBackground = getContentById("background", fields, "self");

  const customBackgroundStyles = _.get(
    customBackground,
    `styles.${format}`,
    {},
  );

  const [layers, setLayers] = useState([]);
  const defaultEffects = {
    isBlur: false,
    isOpacity: false,
    isGradient: false,
    isShadow: false,
    resize: 100,
    ratio: 0,
    ratioUrl: "",
    prevRatio: 0,
    jersey: PresetColors.white,
    time: ResultTimes.halfTime,
    isPenalty: false,
    scrimHeight: DEFAULT_SCRIM_HEIGHT,
  }
  const [effects, setEffects] = useState(defaultEffects)

  useEffect(() => {
    const initialLayers = editData?.layers;
    const initialEffects = editData?.effects;

    if (initialLayers) {
      setTimeout(() => {
        setLayers(initialLayers);
        setEffects(initialEffects ?? defaultEffects);
        if (initialEffects?.ratio > 0) {
          // prevRatioRef.current = initialEffects?.ratio;
        }
      }, 500);
    }
    if (!initialLayers && !editData) {
      const getBackgroundUrls = () => {
        const background = getContentById("background", fields, "self");
        const values = background?.value;
        if (!Array.isArray(values)) return [];

        return values.map((val) => parseMediaUrl(_.get(val, "url", "")));
      }
      const backgroundUrls = getBackgroundUrls();
      const initializeLayers = async () => {
        const newLayerPromises = backgroundUrls.map(async (url, index) => {
          const functions = new Functions(url);
          const finalUrl = functions.getUrl();
          const newDimension = getWrapperDimensions(effects.ratio);
          const newLayer = {
            id: Date.now() + index,
            imageUrl: finalUrl,
            backgroundUrl: url,
            functions,
            dimensions: { width: newDimension.width, height: newDimension.height },
            originalDimensions: { width: newDimension.width, height: newDimension.height },
            nonRatioDimensions: { width: newDimension.width, height: newDimension.height },
            adjustments: { ...DEFAULT_ADJUSTMENTS },
            x: 0,
            y: 0,
            nonRatioX: 0,
            nonRatioY: 0,
            zIndex: index + 1,
            backgroundAndResize: {
              removebg: false,
              removebgUrl: "",
              changebg: false,
              changebgUrl: ""
            },
            isResizing: false,
            isRecreated: false,
          };

          return newLayer;
        });

        const addedLayers = await Promise.all(newLayerPromises);

        setLayers(addedLayers);
        // prevRatioRef.current = 0.56; //default
        setEffects(defaultEffects)
      }
      initializeLayers();
    }
  }, [editData, fields])

  const [ratioSize, setRatioSize] = useState({
    width: 4.075,
    height: 4.075
  });

  useEffect(() => {
    if (prevRatio) {
      setRatioSize(getScaleSize(format, prevRatio));
    } else {
      const editData = data?.data?.editData;
      if (editData) {
        setRatioSize(getScaleSize(format, ratioFromFormat(data.currentFormat)));
      } else {
        setRatioSize(getScaleSize(format, 0));
      }
    }
  }, [format, prevRatio])
  const time = effects?.time;
  const isPenalty = effects?.isPenalty;


  const event = data?.event;
  const isUEFA = event.competitionId === uefaID;
  const isDFBPokal = event.competitionId === dfbPokalId;
  const showMultiline = format === '1920x1080';

  return (
    <div
      id={id}
      className={`T_${templateName} resultTemplate ${animation ? "animation" : ""}`}
    >
      <TemplateBlock>
        <div className={"custom-background-container"}>
          {isUEFA && <div className="ucl-gradient"></div>}
          {isDFBPokal && <div className="dfb-gradient"></div>}
          <div
            id={_.get(customBackground, "id", null)}
            style={customBackgroundStyles}
            className={"custom-background"}
          >
            {layers
              .map((layer, index) => {
                const { id, adjustments, imageUrl, dimensions, x, y } = layer;
                const filterStyles = getImageFilterStyle(adjustments);
                const { colorOverlays = [], ...filterStyle } = filterStyles;
                return (
                  <div
                    style={{
                      position: 'absolute',
                      width: `${dimensions.width * ratioSize.width}px`,
                      height: `${dimensions.height * ratioSize.height}px`,
                      left: `${x * ratioSize.width}px`,
                      top: `${y * ratioSize.height}px`,
                      ...filterStyle
                    }}
                    key={id}
                  >
                    <img
                      src={imageUrl}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: "top"
                      }}
                    />
                    {/* Color overlays */}
                    {colorOverlays.map((overlayStyle, i) => (
                      <div
                        key={i}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          pointerEvents: 'none',
                          ...overlayStyle
                        }}
                      />
                    ))}
                  </div>
                );
              })}
          </div>

          {/* One scrim for the whole frame instead of one per layer, so it
              stays at the foot of the format the score sits on however the
              pictures above it are placed. */}
          {layers.length > 0 && <div style={bottomScrimStyle(effects?.scrimHeight)} />}
        </div>

        <ResultOverlay
          data={data}
          manualEntries={manualEntries}
          time={time}
          isPenalty={isPenalty}
          showMultiline={showMultiline}
        />
      </TemplateBlock>
    </div>
  );
};

export default FCBResultsView;
